export type FeedbackContent = Record<string, unknown> & {
  content?: unknown;
};

export type FeedbackContentTransformer = (
  content: Readonly<FeedbackContent>,
) => FeedbackContent;

export function mergePreparedFeedbackContent<T extends FeedbackContent>(
  defaultContent: T,
  preparedContent?: Record<string, unknown> | null,
): T & Record<string, unknown> {
  return {
    ...defaultContent,
    ...(preparedContent || {}),
  };
}

export function isRequiredFeedbackContentMissing(
  content: FeedbackContent,
  required: boolean,
) {
  if (!required) {
    return false;
  }
  return typeof content.content !== "string" || content.content.trim().length === 0;
}

export function buildFeedbackRequestPayload(
  scene: string,
  content: FeedbackContent,
  transformContent?: FeedbackContentTransformer,
) {
  const requestContent = transformContent ? transformContent(content) : content;
  const { suggestions: suggestion, ...rest } = requestContent;
  return {
    scene,
    suggestion,
    ...rest,
  };
}
